import React from "react";
import { Box, Typography, CircularProgress, alpha } from "@mui/material";
import { Paper } from "@mui/material";

const RepaymentLoading = ({
  title = "Generating Capital Allowance Table",
  description = "Please wait while we calculate your capital allowance breakdown...",
}) => {
  return (
    <Paper
      elevation={0}
      sx={{
        p: 3,
        borderRadius: 2,
        bgcolor: (theme) => alpha(theme.palette.primary.main, 0.01),
        border: (theme) =>
          `1px solid ${alpha(theme.palette.primary.main, 0.1)}`,
        height: "100%",
      }}
    >
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
          minHeight: 300,
          gap: 3,
        }}
      >
        <CircularProgress size={60} thickness={4} />
        <Box sx={{ textAlign: "center" }}>
          <Typography
            variant='h6'
            fontWeight={600}
            color='primary.main'
            gutterBottom
          >
            {title}
          </Typography>
          <Typography variant='body2' color='text.secondary'>
            {description}
          </Typography>
        </Box>
      </Box>
    </Paper>
  );
};

export default RepaymentLoading;
